// The stored `type` attribute lets new kinds arrive without a backfill.
export const MENTION_TYPES = ['member', 'everyone', 'badge'] as const;

export type MentionType = (typeof MENTION_TYPES)[number];

export const isMentionType = (value: unknown): value is MentionType =>
  MENTION_TYPES.some((mentionType) => mentionType === value);
